import { helper } from '@/utils'
import Logo from '../Logo/Logo.vue'
import Company from '../Company/Company.vue'

export default {
  name: 'Reset',
  components: { Company, Logo },
  data () {
    return {
      component: 'reset',
      footer: {},
      primaryColor: '#00BAFF',
      pw_new1: '',
      pw_new2: '',
      reset_error1: false,
      reset_error2: false,
      reset_error3: false,
      state: 'reset',
      title: 'Set New Password'
    }
  },
  methods: {
    getData () {
      return this.getTheme()
        .then(theme => {
          this.footer = {
            companyAddress: theme.company_address,
            companyContact: theme.company_contact,
            companyName: theme.company_name,
            companyUrl: theme.company_url
          }
          this.primaryColor = theme.primary_color
        })
        .catch((error) => helper.showErrorMessage(this, this.component, error))
    },
    getTheme () {
      return this.$api.getTheme()
        .then(({ body }) => body)
    },
    submit () {
      this.reset_error1 = false
      this.reset_error2 = false
      this.reset_error3 = false

      if (this.pw_new1.length < 8 || this.pw_new1.length > 20) {
        this.reset_error1 = true
        return false
      }
      if (this.pw_new1 !== this.pw_new2) {
        this.reset_error2 = true
        return false
      }

      this.$api.updatePassword(this.$route.params.code, this.pw_new1)
        .then((data) => {
          this.state = 'done'
          this.title = 'Password Changed'
        })
        .catch((error) => {
          if (error.status === 400) {
            this.state = 'expired'
            this.title = 'This password reset link is no longer available'
          } else {
            this.reset_error3 = true
          }
        })
    }
  },
  mounted () {
    this.getData()
  }
}



// WEBPACK FOOTER //
// ./src/assets/pages/Reset/Reset.js